import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ErrorDialogService {
  public opened = signal<boolean>(false);
  public message: string = '';
  public status: number | undefined;

  openDialog(message: string, status?: number): void {
    this.message = message;
    this.status = status;
    this.opened.set(true);
  }

  closeDialog(): void {
    this.opened.set(false);
    this.message = '';
    this.status = undefined;
  }
}
